import { defineMessages } from 'react-intl';

export const messages: {
	zero_query: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zero_query_icon_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	zero_query: {
		id: 'search_dialog_zero_query',
		defaultMessage: 'Suggestion',
		description: 'Label for Suggestion search queries',
	},
	zero_query_icon_label: {
		id: 'search_dialog_zero_query_icon_label',
		defaultMessage: 'Suggestion search',
		description: 'Assistive label for Suggestion search queries',
	},
});
